import {
  Confirm as confirm,
  Alert as alert,
  Toast as toast,
  Notify as notify,
  Loading as loading
} from "vue-ydui/dist/lib.rem/dialog";

const dialog = {
  confirm,
  alert,
  toast,
  notify,
  loading
};

function sanitizeErrorText(text) {
  const msg = String(text || "").trim();
  if (!msg) return "";
  if (
    /sqlstate|data too long|integrity constraint|syntax error|exception|stack trace|<html|whoops/i.test(
      msg
    )
  ) {
    return "填写信息有误，请检查后重试";
  }
  if (msg.length > 80) {
    return "操作失败，请稍后重试";
  }
  return msg;
}

export function getErrorMsg(err, fallback = "操作失败，请稍后重试") {
  if (!err) return fallback;
  if (typeof err === "string") {
    return sanitizeErrorText(err) || fallback;
  }
  const data = err.response && err.response.data;
  let raw = "";
  if (data && typeof data === "object") {
    raw = data.msg || data.message || "";
  } else if (typeof data === "string" && data.indexOf("<") !== 0) {
    raw = data;
  }
  if (!raw) raw = err.msg || "";
  if (
    !raw &&
    err.message &&
    !/^Request failed with status code/.test(err.message)
  ) {
    raw = err.message;
  }
  return sanitizeErrorText(raw) || fallback;
}

const icons = { error: "当前暂无网络", success: "操作成功" };
Object.keys(icons).reduce((dialog, key) => {
  dialog[key] = (mes, obj = {}) => {
    const text =
      typeof mes === "string" || mes == null
        ? mes
        : getErrorMsg(mes, icons[key]);
    return new Promise(function(resolve) {
      toast({
        mes: text || icons[key],
        timeout: 2500,
        icon: key,
        callback: () => {
          resolve();
        },
        ...obj
      });
    });
  };
  return dialog;
}, dialog);

dialog.fromError = (err, fallback) => dialog.error(getErrorMsg(err, fallback));

dialog.message = (mes = "当前暂无网络", obj = {}) => {
  return new Promise(function(resolve) {
    toast({
      mes,
      timeout: 2500,
      callback: () => {
        resolve();
      },
      ...obj
    });
  });
};

dialog.validateError = (...args) => {
  validatorDefaultCatch(...args);
};

export function validatorDefaultCatch(err, type = "message") {
  const msg =
    err && err.errors && err.errors[0] && err.errors[0].message
      ? err.errors[0].message
      : "请检查填写信息";
  return dialog[type](msg);
}

export default dialog;
